import { ENUM_FORM_DISPLAY } from "../pageList";
import { getClientUpdateFormSchema } from "../../helpers/getClientUpdateFormSchema";
import { getAddFormSchema as getOrderFormSchema } from "../../pages/operation/order";
import { getAddFormSchema as getUserFormSchema } from "../../pages/operation/user";
import { addFormSchema as debitNoteFormSchema } from "../../pages/gi/debitNote";
import { getQuizFormSchema } from "../../pages/operation/quiz";
import { getProductEditFormSchema } from "../../pages/operation/productEditFormSchema";
import { getProviderEditFormSchema } from "../../pages/operation/provider";
import { getProductTypeFormSchema } from "../../pages/operation/productType";
import { editFormSchema as orderServiceEditFormSchema } from "../../pages/operation/orderService";
import {
  getOrderInvestmentTransactionEditFormSchema,
} from "../../pages/operation/orderInvestmentTransaction";
import { getCpdFormSchema } from "../../pages/operation/cpd";
import {
  getCommissionScheduleEditFormSchema,
} from "../../pages/management/commissionSchedule";

const withMcaModalDisplay = (schema, title) => ({
  ...schema,
  title: title ?? schema.title,
  isMainForm: false,
  display: {
    mode: ENUM_FORM_DISPLAY.MODAL,
    size: schema.display?.size ?? "xl",
  },
  closeAfterSave: true,
  showSaveBar: false,
});

const MCA_ENTITY_FORM_GETTERS = {
  client: (t, opts = {}) =>
    withMcaModalDisplay(
      getClientUpdateFormSchema(t, opts),
      "Revise Client"
    ),
  order: (t) =>
    withMcaModalDisplay(
      { ...getOrderFormSchema(t), title: "Order Details" },
      "Revise Order"
    ),
  debitNote: () =>
    withMcaModalDisplay(
      { ...debitNoteFormSchema, title: "Debit Note Details" },
      "Revise Debit Note"
    ),
  user: (t) =>
    withMcaModalDisplay(getUserFormSchema(t), "Revise User"),
  quiz: () => withMcaModalDisplay(getQuizFormSchema(), "Revise Quiz"),
  product: () =>
    withMcaModalDisplay(getProductEditFormSchema(), "Revise Product"),
  provider: () =>
    withMcaModalDisplay(getProviderEditFormSchema(), "Revise Provider"),
  productType: () =>
    withMcaModalDisplay(getProductTypeFormSchema(), "Revise Product Type"),
  orderService: () =>
    withMcaModalDisplay(orderServiceEditFormSchema, "Revise Order Service"),
  orderInvestmentTransaction: () =>
    withMcaModalDisplay(
      getOrderInvestmentTransactionEditFormSchema(),
      "Revise Investment Transaction"
    ),
  cpd: () => withMcaModalDisplay(getCpdFormSchema(), "Revise CPD Record"),
  commissionSchedule: () =>
    withMcaModalDisplay(
      getCommissionScheduleEditFormSchema(),
      "Revise Commission Schedule"
    ),
};

export const getMcaEntityFormSchema = (entityKey, t, opts = {}) => {
  const getter = MCA_ENTITY_FORM_GETTERS[entityKey];
  if (!getter) return null;
  return getter(t, opts);
};

export const hasMcaEntityForm = (entityKey) =>
  Object.prototype.hasOwnProperty.call(MCA_ENTITY_FORM_GETTERS, entityKey);
